import React from 'react';
// @ts-ignore
import Loadable from '@docusaurus/react-loadable';
import BlockLoader from '@/ui/BlockLoader';

// usage: React.lazy(() => imports.betslip().then(pickModule('BetslipEditor')));
export const pickModule = module => modules => ({ default: modules.default[module] });

export function defaultResolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}

// bez tohto logovania by sme nevedeli, preco sa neresolvne chunk
function withErrorLogger(Component) {
    return function(props) {
        if (props.error) {
            console.error(props.error);
        }

        return <Component {...props} />;
    };
}

export default function NikeLoadable(opts) {
    const merged = Object.assign(
        {
            loading: BlockLoader,
            delay: 0
            // timeout: 10
        },
        opts
    );
    if (opts.exp) {
        merged.render = function render(loaded, props) {
            return React.createElement(opts.exp(defaultResolve(loaded)), props);
        };
    }

    merged.loading = withErrorLogger(merged.loading);
    if (typeof merged.loader === 'function') {
        return Loadable(merged);
    }
    return Loadable.Map(merged);
}
